import {
  Box,
  Divider,
  Flex,
  Grid,
  GridItem,
  Heading,
  List,
  ListItem,
  OrderedList,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { FaFacebook, FaLinkedin, FaWhatsapp } from "react-icons/fa";

import { isArray } from "lodash";
import ReactHtmlParser from "react-html-parser";
import { IoLogoInstagram } from "react-icons/io";
import { RiTwitterXFill } from "react-icons/ri";
import { FooterProps } from "../../@types";
import { DEFAULT_BRAND_LOGO } from "../../constant/placeholders";
import HTMLRenderer from "../HTMLRenderer";
import Image from "../Image";
import Link from "../Link";

function Footer({
  logo,
  description,
  companyName,
  footerSections,
  footerCopyRightSection,
  listType = "unordered",
  footerGridProps,
  footerGridItemProps,
  footerContainerProps,
  footerListContainerProps,
  footerListItemProps,
  footerInsideContainerProps,
  infoSectionProps,
  htmlContentProps,
  logoProps,
  footerCopyRightSectionProps,
  iconRender,
  iconProps,
  iconContainerProps,
  socialMediaLinks,
  footerSectionContentProps,
}: FooterProps) {
  const ListElement =
    listType === "ordered"
      ? OrderedList
      : listType === "unordered"
        ? UnorderedList
        : List;

  return (
    <Box {...footerContainerProps} pb={10}>
      <Box {...footerInsideContainerProps}>
        <Grid
          alignItems={{
            base: "center",
            lg: "flex-start",
          }}
          templateColumns={{
            base: "repeat(1, 1fr)",
            lg: `repeat(${footerSections ? footerSections.length + 1 : 5},1fr)`,
          }}
          textAlign={{
            base: "center",
            lg: "left",
          }}
          gap={{
            base: "5",
            md: "1rem",
          }}
          w={"100%"}
          {...footerGridProps}
        >
          <GridItem
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: {
                base: "center",
                lg: "flex-start",
              },
            }}
            {...footerGridItemProps}
          >
            <Image
              maxW="14rem"
              id="brand_logo"
              className="navbar__brand__logo"
              src={logo}
              fallbackSrc={DEFAULT_BRAND_LOGO}
              alt="Logo"
              height={{
                base: "2rem",
                sm: "3rem",
                md: "3rem",
                xl: "3rem",
              }}
              {...logoProps}
            />
            <Box {...htmlContentProps}>
              <HTMLRenderer htmlElement={description || ""} />
            </Box>
            <Box>
              {iconRender ? (
                <HTMLRenderer htmlElement={iconRender} />
              ) : (
                socialMediaLinks && (
                  <Flex gap={2} {...iconContainerProps}>
                    {socialMediaLinks.facebook && (
                      <Link href={socialMediaLinks.facebook}>
                        <FaFacebook {...iconProps} size="30px" />
                      </Link>
                    )}
                    {socialMediaLinks.instagram && (
                      <Link href={socialMediaLinks.instagram}>
                        <IoLogoInstagram size="30px" {...iconProps} />
                      </Link>
                    )}
                    {socialMediaLinks.linkdin && (
                      <Link href={socialMediaLinks.linkdin}>
                        <FaLinkedin size="30px" {...iconProps} />
                      </Link>
                    )}
                    {socialMediaLinks.twitter && (
                      <Link href={socialMediaLinks.twitter}>
                        <RiTwitterXFill size="30px" {...iconProps} />
                      </Link>
                    )}
                    {socialMediaLinks.whatsapp && (
                      <Link href={socialMediaLinks.whatsapp}>
                        <FaWhatsapp size="30px" {...iconProps} />
                      </Link>
                    )}
                  </Flex>
                )
              )}
            </Box>
          </GridItem>
          {footerSections?.map((section, index) =>
            section.content && isArray(section.content) ? (
              <Flex
                flexDirection="column"
                gap={4}
                alignItems={{
                  base: "center",
                  lg: "flex-start",
                }}
                border="1px solid red"
                {...infoSectionProps}
              >
                {section.title && (
                  <Heading
                    as="h6"
                    size="sm"
                    color="primary.500"
                    textTransform="uppercase"
                    {...section.titleProps}
                  >
                    {section.title}
                  </Heading>
                )}
                {section.content.map((sec, inde) => (
                  <Box key={`footer__sec__${inde}`}>
                    <Heading
                      as="h6"
                      size="sm"
                      color="primary.500"
                      textTransform="uppercase"
                      {...footerSectionContentProps}
                    >
                      {sec.title}
                    </Heading>
                    <>
                      {sec.contentHtml ? (
                        typeof sec.contentHtml === "string" ? (
                          ReactHtmlParser(sec.contentHtml)
                        ) : (
                          sec.contentHtml
                        )
                      ) : (
                        <ListElement
                          mt="1rem"
                          spacing={1}
                          listStyleType="none"
                          sx={{
                            listStyleType: "none",
                            "& li": {
                              listStyle: "none",
                            },
                          }}
                          {...footerListContainerProps}
                        >
                          {sec.links?.map((link, i) => (
                            <ListItem
                              {...footerListItemProps}
                              key={`footer__section__link__${i}`}
                            >
                              <Flex align="center" gap={2}>
                                {link.prefixIcon && (
                                  <Box
                                    fontSize="sm"
                                    display="flex"
                                    alignItems="center"
                                  >
                                    {typeof link.prefixIcon === "string" ? (
                                      link.prefixIcon.startsWith("http") ? (
                                        <Image
                                          src={link.prefixIcon}
                                          alt="icon"
                                          width="16px"
                                          height="16px"
                                          objectFit="contain"
                                        />
                                      ) : link.prefixIcon.startsWith("<svg") ? (
                                        <Box
                                          width="16px"
                                          height="16px"
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="center"
                                          color="primary.500"
                                          dangerouslySetInnerHTML={{
                                            __html: link.prefixIcon,
                                          }}
                                        />
                                      ) : (
                                        <Text fontSize="sm">
                                          {link.prefixIcon}
                                        </Text>
                                      )
                                    ) : (
                                      link.prefixIcon
                                    )}
                                  </Box>
                                )}
                                {link.href ? (
                                  <Link href={link.href} {...link.labelProps}>
                                    {link.label}
                                  </Link>
                                ) : (
                                  <Text {...link.labelTextProps}>
                                    {link.label}
                                  </Text>
                                )}
                              </Flex>
                            </ListItem>
                          ))}
                        </ListElement>
                      )}
                    </>
                  </Box>
                ))}
              </Flex>
            ) : (
              <GridItem
                key={`footer__section__${index}`}
                mt={{
                  base: 2,
                  lg: 14,
                }}
                {...infoSectionProps}
              >
                <Box
                  fontSize={{
                    base: "xs",
                  }}
                >
                  <>
                    <Heading
                      as="h6"
                      size="sm"
                      color="primary.500"
                      textTransform="uppercase"
                      {...section.titleProps}
                    >
                      {section.title}
                    </Heading>
                    {section.contentHtml ? (
                      typeof section.contentHtml === "string" ? (
                        ReactHtmlParser(section.contentHtml)
                      ) : (
                        section.contentHtml
                      )
                    ) : (
                      <ListElement
                        mt="0.5rem"
                        spacing={1}
                        listStyleType="none"
                        sx={{
                          listStyleType: "none",
                          "& li": {
                            listStyle: "none",
                          },
                        }}
                        {...footerListContainerProps}
                      >
                        {section.links?.map((link, i) => (
                          <ListItem
                            key={`footer__section__link__${i}`}
                            fontSize={{
                              base: "xs",
                              xl: "md",
                            }}
                            {...footerListItemProps}
                          >
                            <Flex align="center" gap={2}>
                              {link.prefixIcon && (
                                <Box
                                  fontSize="sm"
                                  display="flex"
                                  alignItems="center"
                                >
                                  {typeof link.prefixIcon === "string" ? (
                                    link.prefixIcon.startsWith("http") ? (
                                      <Image
                                        src={link.prefixIcon}
                                        alt="icon"
                                        width="16px"
                                        height="16px"
                                        objectFit="contain"
                                      />
                                    ) : link.prefixIcon.startsWith("<svg") ? (
                                      <Box
                                        width="16px"
                                        height="16px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        color="primary.500"
                                        dangerouslySetInnerHTML={{
                                          __html: link.prefixIcon,
                                        }}
                                      />
                                    ) : (
                                      <Text fontSize="sm">
                                        {link.prefixIcon}
                                      </Text>
                                    )
                                  ) : (
                                    link.prefixIcon
                                  )}
                                </Box>
                              )}
                              {link.href ? (
                                <Link href={link.href} {...link.labelProps}>
                                  {link.label}
                                </Link>
                              ) : (
                                <Text {...link.labelTextProps}>
                                  {link.label}
                                </Text>
                              )}
                            </Flex>
                          </ListItem>
                        ))}
                      </ListElement>
                    )}
                  </>
                </Box>
              </GridItem>
            ),
          )}
        </Grid>
        <Divider m="4" zIndex={1} />
        {footerCopyRightSection ? (
          ReactHtmlParser(footerCopyRightSection)
        ) : (
          <Text
            textColor={"surface.white"}
            fontSize={{
              base: "xs",
            }}
            {...footerCopyRightSectionProps}
          >
            Copyright © {new Date().getFullYear()} {companyName}. All rights
            reserved. | Powered by{" "}
            <a
              href="https://picovico.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              PicoVico
            </a>{" "}
            | Privacy Policy
          </Text>
        )}
      </Box>
    </Box>
  );
}

export default Footer;
